import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import classnames from 'classnames/bind';
import { getCookie } from 'utils/cookie';
import { MODAL_STATE } from 'store/actions/modal';
import ProfileForm from './ProfileForm';
import EmailConfirmationForm from './EmailConfirmationForm';
import styles from './WelcomeBackModal.module.scss';

const cx = classnames.bind(styles);

const WelcomeBackModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const { username, first_name, last_name, email, isLoading, email_confirmed } = useSelector(({ user }) => user);
  const isPasswordValidationFailed = getCookie('password_validation_failed');
  const dispatch = useDispatch();

  useEffect(() => {
    const shouldOpenModal =
      username && !isFormSubmitted && !isLoading && (!first_name || !last_name || isPasswordValidationFailed || !email_confirmed);

    if (shouldOpenModal) {
      setModalOpen(true);
      dispatch({ type: MODAL_STATE, status: 'open' });
    }
  }, [username, first_name, last_name, isFormSubmitted]);

  const handleModalClose = () => {
    setModalOpen(false);
    setIsFormSubmitted(true);
  };

  let shouldShowProfileForm;
  let shouldShowEmailForm;

  if(!first_name || !last_name || !email || isPasswordValidationFailed) {
    shouldShowProfileForm = true;
  } else if(!email_confirmed) {
    shouldShowEmailForm = true;
  }

  return (
    <Modal className={cx('modal-body')} isOpen={modalOpen}>
      {shouldShowProfileForm && <ProfileForm onModalClose={handleModalClose} />}
      {!shouldShowProfileForm && shouldShowEmailForm && <EmailConfirmationForm onModalClose={handleModalClose} />}
    </Modal>
  );
};

export default WelcomeBackModal;
